

































































































































































































































import {Component, Prop} from 'vue-property-decorator'
import FilterButton from '../components/FilterButton.vue'
import LoadingDummy from '../components/LoadingDummy.vue'
import IssueRow from '../components/Issue/IssueRow.vue'
import {Issue, IssueConst} from '../models/Issue'
import Helper from '../services/Helper.js'
import ListView from './ListView'

@Component({
  components: {LoadingDummy, IssueRow, FilterButton},
})
export default class ViewIssue extends ListView<Issue> {
  @Prop() noSearch: boolean


  IssueConst = IssueConst
  isPickingDate = false


  store = this.$store.state.issue

  drawer_ratio = 0.2

  commit_prefix = 'issue'
  base_url = Helper.setting.issue.getListAPI

  isForceReload = true



  beforeLoad() {
    // if (this.$route.params.status) {
    //   this.setFilter('status', this.$route.params.status)
    // }
    if (this.$route.params.status) {
      this.store.filter['status'].current.push({
        key: this.$route.params.status,
        text: this.$route.params.status,
        count: 0,
      })
    }
    if (this.$route.params.from) {
      this.dateFrom = this.$route.params.from
      this.store.dateFrom = this.dateFrom
    }
    if (this.$route.params.to) {
      this.dateTo = this.$route.params.to
      this.store.dateTo = this.dateTo
    }
  }

  onListLoaded(data) {
    if (this.$route.params.id) {
      console.log('onListLoaded', data)
      let index: number = -1

      for (let i in data.data) {
        const issue: Issue = data.data[i]
        if (issue.id == parseInt(this.$route.params.id)) {
          index = parseInt(i)
        }
      }


      if (index >= 0) {
        this.$store.commit('dialog_is_issue', {toggle: true, index: index})
      }
    }
    return
  }

  setDateLastMonth() {
    var tzoffset = (new Date()).getTimezoneOffset() * 60000
    // let tmpDateFrom = (new Date(Date.now() - tzoffset))
    var tmpDateFrom = new Date(Date.now())
    // tmpDateFrom.setMonth(tmpDateFrom.getMonth() - 1)
    tmpDateFrom.setDate(0)
    this.dateTo = (new Date(tmpDateFrom.getTime() - tzoffset)).toISOString().substr(0, 10)
    tmpDateFrom.setDate(1)
    this.dateFrom = (new Date(tmpDateFrom.getTime() - tzoffset)).toISOString().substr(0, 10)
    this.reload()
  }

  setDateThisMonth() {
    var tzoffset = (new Date()).getTimezoneOffset() * 60000
    var tmpDateFrom = new Date(Date.now())
    tmpDateFrom.setDate(1)
    this.dateFrom = (new Date(tmpDateFrom.getTime() - tzoffset)).toISOString().substr(0, 10)
    this.dateTo = (new Date(Date.now() - tzoffset)).toISOString().substr(0, 10)
    this.reload()
  }

  setDateToday() {
    var tzoffset = (new Date()).getTimezoneOffset() * 60000
    let tmpDateFrom = (new Date(Date.now() - tzoffset))

    this.dateFrom = tmpDateFrom.toISOString().substr(0, 10)
    this.dateTo = tmpDateFrom.toISOString().substr(0, 10)
    this.reload()
  }


}
